'use client';

import downloadFile from '@/features/contentful/ContentfulGeneric/ComponentWrappers/FormHousing/download';
import getAssetByFilename from './getAssetByFilename';

export const isIOS =
    typeof window !== 'undefined' &&
    /ipad|iphone|safari/i.test(navigator.userAgent) &&
    !/chrome/i.test(navigator.userAgent);

export const handleLinkClick = async (e: React.MouseEvent<HTMLAnchorElement>, url?: string) => {
    // Check if the device is iOS
    if (isIOS && url) {
        // For iOS devices, use a different approach to download the file
        e.preventDefault();

        if (url.startsWith('/assets/')) {
          // TODO: Dima to fix
            // for assets with internal url, we need to fetch the asset from Contentful and after that download it
            // const matchingAsset = await getAssetByFilename(url.replace('/assets/', ''));
            //
            // if (matchingAsset && matchingAsset.fields.file) {
            //     downloadFile(`https:${matchingAsset.fields.file.url}`);
            // }
        } else {
            downloadFile(`https:${url}`);
        }
    }
};
